module.exports = __webpack_public_path__ + "static/media/hard-drive.d47406a9.svg";